import { useState } from "react";
import { Helmet } from "react-helmet";

import '../components/Styles/galleria.css'
import pf2a from "../assets/images/pf2a.png";
import pf3a from "../assets/images/pf3a.png";
import pf4a from "../assets/images/pf4a.png";
import pf5a from "../assets/images/pf5a.png";
import pf6a from "../assets/images/pf6a.png";
import pf7a from "../assets/images/pf7a.png";

const SIZES = ["1 person", "2–3 people", "4–6 people", "7+ people"];
const TIMELINES = ["Immediately", "Within 30 days", "1–3 months", "Just exploring"];

const AMENITIES = [
  ["Private, furnished office", "Your own dedicated workspace."],
  ["Professional business address", "Establish your company in Houston's Galleria district."],
  ["Meeting room access", "Professional spaces when you need to meet clients or your team."],
  ["Reception and professional environment", "Give clients the right impression from the moment they arrive."],
  ["Houston skyline views", "A space designed to feel professional, modern, and established."],
  ["Flexible workspace amenities", "Everything you need to focus on your business."],
];

const AUDIENCES = [
  ["Law firms", "Secure, private offices with high speed internet and confidential meeting rooms."],
  ["Financial advisors", "Professional workspace with quiet zones for client consultations and focused work."],
  ["Real estate brokerages", "Flexible offices and meeting rooms ideal for closings and client presentations."],
  ["Consultants", "Productive, fully equipped spaces designed for collaboration and networking."],
  ["Sales organizations", "Reliable workspace with business grade internet and team collaboration areas."],
  ["Investment professionals", "Private offices and comfortable lounges for strategic discussions and client meetings."],
  ["International companies entering Houston", "Flexible membership plans and ready to use offices for a smooth market entry."],
];

const FAQS = [
  ["How does the One Month on You, One Month on Us promotion work?",
   "With a qualifying 12 month agreement, you pay one month's rent and the following month's rent is included by Xceed. The pattern continues throughout the agreement, resulting in six months of rent being included."],
  ["Is this the same as 50% off?",
   "Over the full 12 month agreement, the promotion provides the equivalent of six months of rent. Payments are structured as alternating paid and included months rather than reducing every monthly payment by 50%."],
  ["Are all offices included?",
   "Availability and eligibility may vary by office. Our team can show you the spaces currently available under the promotion."],
  ["Can I tour the offices before signing?",
   "Yes. Submit the form and our team can arrange a tour of available spaces."],
  ["Where is Xceed Office located?",
   "3050 Post Oak Blvd, Houston, TX 77056, in the Galleria district."],
];

const GALLERY = [
  { id: "g1", src: pf3a, alt: "Private office desk" },
  { id: "g2", src: pf4a, alt: "Conference room" },
  { id: "g3", src: pf5a, alt: "Reception area" },
  { id: "g4", src: pf6a, alt: "Lounge seating" },
  { id: "g5", src: pf7a, alt: "Skyline view office" },
];

function LeadForm({ id, compact = false }) {
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: send new FormData(e.currentTarget) to your backend / CRM
    setSent(true);
  };

  if (sent) {
    return (
      <div className="form-card form-done" role="status">
        <h3>Thanks, we've got your request.</h3>
        <p>Our team will contact you shortly with available offices and pricing.</p>
      </div>
    );
  }

  return (

    
    <form className={`form-card ${compact ? "form-compact" : ""}`} onSubmit={handleSubmit}>
      {!compact && (
        <>
          <h3>Claim Your Private Office Offer</h3>
          <p className="form-sub">
            Tell us what you're looking for and our team will contact you with available offices and pricing.
          </p>
        </>
      )}

      <div className="row">
        <label htmlFor={`${id}-first`}>First Name *
          <input id={`${id}-first`} name="firstName" placeholder="First name" required />
        </label>
        {!compact && (
          <label htmlFor={`${id}-last`}>Last Name *
            <input id={`${id}-last`} name="lastName" placeholder="Last name" required />
          </label>
        )}
      </div>

      <label htmlFor={`${id}-phone`}>Phone Number *
        <input id={`${id}-phone`} name="phone" type="tel" placeholder="(713) 555-0100" required />
      </label>

      <label htmlFor={`${id}-email`}>Email Address *
        <input id={`${id}-email`} name="email" type="email" placeholder="you@company.com" required />
      </label>

      {!compact && (
        <label htmlFor={`${id}-company`}>Company Name
          <input id={`${id}-company`} name="company" placeholder="Company name" />
        </label>
      )}

      <div className="row">
        <label htmlFor={`${id}-size`}>How many people need an office?
          <select id={`${id}-size`} name="size" defaultValue="">
            <option value="" disabled>Select office size</option>
            {SIZES.map((s) => <option key={s}>{s}</option>)}
          </select>
        </label>
        {!compact && (
          <label htmlFor={`${id}-move`}>When are you looking to move in?
            <select id={`${id}-move`} name="timeline" defaultValue="">
              <option value="" disabled>Select timeline</option>
              {TIMELINES.map((t) => <option key={t}>{t}</option>)}
            </select>
          </label>
        )}
      </div>

      <button type="submit" className="btn btn-block">Claim My Offer</button>
      <p className="fine">
        By submitting this form, you agree to be contacted by Xceed Office regarding your inquiry.
      </p>
    </form>
  );
}

export default function XceedLanding() {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <div className="xo">
      <Helmet>
        <title>
          Private Offices in Houston Galleria | 12 Months, Pay for 6 | Xceed Office
        </title>

        <meta
          name="description"
          content="Get a private furnished office in Houston’s Galleria. Sign a 12-month agreement and pay for 6 months. Check current availability at Xceed Office."
        />

        <meta
          name="robots"
          content="noindex, follow"
        />
      </Helmet>
   <header className="xo-topbar">
  <div className="wrap topbar-row">
    <a href="/" className="topbar-brand">
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M4 4h16v16H4z" />
        <path d="M9 9h6M9 13h6M9 17h3" />
      </svg>
      <span style={{color:"white"}}>XCEED OFFICE</span>
    </a>

    <a href="tel:+13463877187" className="topbar-phone">
      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
      </svg>
      <span>Call us: (346) 387-7187</span>
    </a>
  </div>
</header>
      {/* Hero */}
      <section  className="hero">
        <div className="wrap hero-grid">
          <div className="hero-copy">
            <p className="kicker">Private Offices in the Galleria</p>
            <h1>
              One Month on You.
              <br />
              <span className="gold">One Month on Us.</span>
            </h1>
            <p className="lead">
              Move into a professional private office in Houston's Galleria and alternate your rent with us.
              With a 12-month agreement, you pay for 6 months — <strong>and we cover the other 6.</strong>
            </p>
            <a href="#claim" className="btn">Claim This Offer</a>
            <p className="fine">Limited availability. Terms apply.</p>
          </div>
          <LeadForm id="hero" />
        </div>
      </section>

      {/* Offer */}
      <section className="section center">
        <div className="wrap">
          <h2>A Full Year of Office Space. <span className="gold">You Pay for Half.</span></h2>
          <p className="muted">The offer is simple:</p>
          <ol className="months">
            {["You Pay", "On Us", "You Pay", "On Us"].map((label, i) => (
              <li key={i} className={i % 2 ? "free" : ""}>
                <span className="m-label">Month {i + 1}</span>
                <strong>{label}</strong>
              </li>
            ))}
          </ol>
          <p className="muted">…continues for 12 months</p>
          <p className="big">12 Months.<br /><span className="gold">Pay for 6.</span></p>
          <p className="muted narrow">
            No complicated discount structure. Just a professional private office in one of Houston's most
            recognized business districts with six months of rent included.
          </p>
          <a href="#claim" className="btn">Check Availability</a>
        </div>
      </section>

      {/* Amenities */}
      <section className="section center">
        <div className="wrap">
          <h2>Your Own Professional Private Office</h2>
          <p className="muted narrow">
            A workspace designed for professionals who want more than a desk. Your private office gives you a
            professional environment to work, meet clients, and grow your business without the overhead of
            managing a traditional office.
          </p>
          <div className="grid g3">
            {AMENITIES.map(([t, d]) => (
              <article className="card" key={t}>
                <h3>{t}</h3>
                <p>{d}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Find a space */}
      <section className="section">
  <div className="wrap split">
    <img className="img-ph split-img" src={pf2a} alt="Furnished private office lounge" />
    <div className="split-copy">
      <h2>Find a Space That Fits Your Business</h2>
      <p className="muted">Private offices designed for professionals and growing businesses.</p>
      <ul className="checks">
        <li>Furnished</li>
        <li>Ready to move in</li>
        <li>Professional environment</li>
      </ul>
      <a href="#claim" className="btn">View Availability</a>
    </div>
  </div>
</section>
      {/* Gallery */}
      <section className="section center">
        <div className="wrap">
          <h2>See the <span className="gold">Space</span></h2>
          <p className="muted narrow">
            From individual private offices to larger executive spaces, choose the workspace that fits the way
            you work.
          </p>
<div className="gallery">
  {GALLERY.map((img) => (
    <img
      key={img.id}
      className={`img-ph ${img.id}`}
      src={img.src}
      alt={img.alt}
    />
  ))}
</div>
        </div>
      </section>

      {/* Location */}
      <section style={{background:"#141414"}} className="section">
        <div style={{background:"#141414"}} className="wrap split">
          <div style={{background:"#141414"}} className="split-copy">
            <h2>Work in the Heart of Houston's Galleria</h2>
            <address>
              <strong>Xceed Office</strong>
              <br />3050 Post Oak Blvd
              <br />Houston, TX 77056
            </address>
            <p className="muted">
              Position your business in one of Houston's most established commercial districts, close to major
              businesses, restaurants, hotels, and the Galleria.
            </p>
            <a href="#claim" className="btn">Schedule a Tour</a>
          </div>
          <iframe style={{background:"#141414"}}
            className="map"
            title="Xceed Office location map"
            loading="lazy"
            src="https://www.google.com/maps?q=3050+Post+Oak+Blvd,+Houston,+TX+77056&output=embed"
          />
        </div>
      </section>

      {/* Audiences */}
      <section className="section center">
        <div className="wrap">
          <h2>Built for Professionals Who Need a Real Office</h2>
          <p className="muted narrow">
            Whether you're moving out of a home office, opening a Houston location, or simply looking for a more
            professional place to meet clients, Xceed gives you a ready to use office without the complexity of a
            traditional lease.
          </p>
          <div className="grid g4">
            {AUDIENCES.map(([t, d]) => (
              <article className="card" key={t}>
                <h3>{t}</h3>
                <p>{d}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Second form */}
      <section style={{background:"#141414"}} className="section center" id="claim">
        <div className="wrap form-wrap">
          <h2>See What's <span className="gold">Available</span></h2>
          <p className="kicker">12 Month Agreement • Pay for 6 Months</p>
          <LeadForm id="bottom" compact />
        </div>
      </section>

      {/* FAQ */}
      <section className="section">
        <div className="wrap faq">
          <h2 className="center-text">Frequently Asked <span className="gold">Questions</span></h2>
          {FAQS.map(([q, a], i) => {
            const open = openFaq === i;
            return (
              <div className={`faq-item ${open ? "open" : ""}`} key={q}>
                <button
                  className="faq-q"
                  aria-expanded={open}
                  aria-controls={`faq-${i}`}
                  onClick={() => setOpenFaq(open ? -1 : i)}
                >
                  {q}
                  <span className="chev" aria-hidden="true" />
                </button>
                {open && <p id={`faq-${i}`} className="faq-a">{a}</p>}
              </div>
            );
          })}
        </div>
      </section>

      {/* Final CTA */}
      <section className="section center final">
        <div className="wrap">
          <h2>Your Next Office Could Cost You <span className="gold">Half the Year's Rent.</span></h2>
          <p className="gold strong">One month on you. One month on us.</p>
          <p className="muted">With a qualifying 12 month agreement.</p>
          <a href="#claim" className="btn">Claim the Offer</a>
          <p className="fine">Limited availability. Eligibility and terms apply.</p>
        </div>
      </section>

      <footer className="foot">
        <div className="wrap foot-row">
          <div>
            <strong>Xceed Office</strong>
            <br />3050 Post Oak Blvd, Houston, TX 77056
          </div>
          <div className="foot-links">
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms</a>
          </div>
          <div>© 2026 Xceed Office</div>
        </div>
      </footer>
    </div>
  );
}
